module.exports = __webpack_public_path__ + "img/keyboard_Arrow_Down.6909ef3e.png";